import { cn } from '@/lib/utils'
import { Wordmark } from './Wordmark'

type LogoState = 'static' | 'breathing' | 'shimmer'
type LogoSize  = 'sm' | 'md' | 'lg'

const sizeClasses: Record<LogoSize, string> = {
  sm: 'w-6 h-6',
  md: 'w-8 h-8',
  lg: 'w-10 h-10',
}

export function Logo({
  state = 'static',
  size  = 'md',
  className,
}: {
  state?: LogoState
  size?:  LogoSize
  className?: string
}) {
  const dotClass = (i: 1 | 2 | 3) => cn(
    'rounded-full bg-[var(--text-primary)]',
    sizeClasses[size],
    state === 'breathing' && 'animate-breathe',
    state === 'shimmer'   && i === 1 && 'animate-shimmer-1',
    state === 'shimmer'   && i === 2 && 'animate-shimmer-2',
    state === 'shimmer'   && i === 3 && 'animate-shimmer-3',
  )

  return (
    <div className={cn('flex items-center gap-1', className)}>
      <span className={dotClass(1)} />
      <span className={dotClass(2)} />
      <span className={dotClass(3)} />
    </div>
  )
}

export function LogoWordmark({ className }: { className?: string }) {
  // Canon (ADR-001 2026-07-11): the wordmark is the canonical <Wordmark>
  // (Fraunces italic 700). Previously this rendered a hand-styled font-mono
  // treatment, off-canon.
  return <Wordmark size="sm" className={className} />
}
